import {useEffect} from 'react';
import {socket} from "./soket";
import useStore from "../store";

function StatusGame() {
    const showSoon = useStore(state => state.showSoon);

    useEffect(() => {
        socket.emit('game_status')
        socket.on('game_status', data => {
            if (data.error) {
            } else {
                if (data.soon) {
                    showSoon(true)
                } else if (data.game) {
                    showSoon(false)
                } else if (data.endgame) {
                    showSoon(false)
                }
            }

        });
        return () => {
            socket.off('game_status');
        };
    }, [])
    return null

}

export default StatusGame;
